import { useState } from 'react';
import ButtonSpinner from '../ButtonSpinner';
import { BTN_PRIMARY } from '../buttonStyles';
import { BTN_ON_CANVAS } from './RoomScreens';
import { resolvePlayerNoShow } from '../../services/liveV2';
import { liveLessonsErrorMessage } from '../../services/liveLessons';
import { useToast } from '../../hooks/useToast';

/**
 * The coach's decision on a player no-show, in the call and on its left screen (decision 154;
 * booking-contracts.md 13): Count This Lesson, the primary, and Offer a New Time (resolvePlayerNoShow).
 * The booking's own listener brings the decided line back; the toast says what happened at once.
 */
export function NoShowDecision({ bookingId, playerFirst, member }: { bookingId: string; playerFirst: string; member: boolean }) {
  const { showError, showSuccess } = useToast();
  const [busy, setBusy] = useState<'count' | 'offer' | null>(null);
  const resolve = async (choice: 'count' | 'offer') => {
    setBusy(choice);
    try {
      await resolvePlayerNoShow({ bookingId, choice });
      showSuccess(choice === 'count' ? 'Lesson counted.'
        : member ? `The lesson is back in ${playerFirst}'s month.` : `${playerFirst} can pick a new time.`);
    } catch (err) {
      showError(liveLessonsErrorMessage(err, choice === 'count' ? 'Could not count the lesson. Please try again.' : 'Could not offer a new time. Please try again.'));
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="flex w-full max-w-[320px] flex-col gap-2" data-no-show-decision>
      <button type="button" onClick={() => { void resolve('count'); }} disabled={!!busy} aria-busy={busy === 'count'}
        className={`${BTN_PRIMARY} w-full`} data-count-lesson>{busy === 'count' ? <ButtonSpinner /> : 'Count This Lesson'}</button>
      <button type="button" onClick={() => { void resolve('offer'); }} disabled={!!busy} aria-busy={busy === 'offer'}
        className={`${BTN_ON_CANVAS} w-full`} data-offer-new-time>{busy === 'offer' ? <ButtonSpinner /> : 'Offer a New Time'}</button>
    </div>
  );
}
